import * as React from "react";
import LoginPopup from "../generic/loginPopup";
import DeviceContext from "../../../services/indentifyDevice";
import { ELoginPopupState } from "../../../Containers/Client/Login/loginConstants";
import "../../../assets/scss/Login/login/loginScreen/loginScreen.scss";
import { Link, RouteChildrenProps } from "react-router-dom";
import LoginStatusScreen from "./loginStatusScreen";
import LoginService, { getPreLoginData } from "../../../services/login/loginService";
import ForgotPasswordForm from "../forms/forgotPasswordForm";
import { ForgotPasswordScreenEnum } from "../../types/components/login/loginTypes";
import OtpForm from "../forms/otpForm";
import {
  AClientResetPassword,
  AClientKamResetPassword,
  AValidateOTP,
} from "../../../services/login/loginApiService";
import ResetPassword from "../forms/resetPassword";
import NuvamaLogo from "../../../assets/new_images/nuvama-logo.svg";
import ResetOtpPassword from "../forms/resetOtpPassword";

export interface IForgotPasswordScreenProps {}

export interface IForgotPasswordScreenState {
  popupMessage: string;
  screenState: ForgotPasswordScreenEnum;
  errorMsg?: string;
  attempts: number;
  loginId: string;
  disableForm: boolean;
}

class ForgotPasswordScreen extends React.Component<
  IForgotPasswordScreenProps & RouteChildrenProps,
  IForgotPasswordScreenState
> {
  state = {
    popupMessage: "",
    screenState: ForgotPasswordScreenEnum.FORGOT_PASSWORD,
    errorMsg: "",
    attempts: 3,
    loginId: "",
    disableForm: false,
  };

  onClose = () => {
    this.props.history.push("/login/help");
  };

  onForgetFormSubmit = (
    popupMessage: string,
    screenState: ForgotPasswordScreenEnum,
    loginId: string = this.state.loginId
  ) => {
    this.setState({
      ...this.state,
      errorMsg: "",
      popupMessage,
      screenState,
      loginId,
    });
  };

  onSubmitOTPForm = (otp: string) => {
    let payload = {
      loginId: this.state.loginId,
      accTyp: "EQ",
      otp: otp,
    };
    AValidateOTP(this.onSubmitOTPFormRes, payload);
    // this.onSubmitOTPFormRes(payload);
  };

  onSubmitOTPFormRes = (res: any) => {
    console.log(res);
    if (res.data && res?.data) {
      this.setState({
        ...this.state,
        errorMsg: "",
        screenState: ForgotPasswordScreenEnum.RESET_PASSWORD,
      });
    } else if (res.error) {
      if (this.state.attempts <= 1) {
        this.setState({
          ...this.state,
          errorMsg: "You have exceeded the maximum number of attempts",
          attempts: 0,
          disableForm: true,
        });
      } else {
        this.setState({
          ...this.state,
          errorMsg: res.error.errMsg,
          attempts: this.state.attempts - 1,
        });
      }
    }
  };

  clientResetPasswordApi = (form: any) => {
    let payload = {
      loginId: this.state.loginId,
      ...form,
    };
    AClientResetPassword(this.clientResetPasswordRes, payload);
  };
  clientKamResetPasswordApi = (form: any, otp:string) => {
    let payload = {
      loginId: this.state.loginId,
      ...form,
      otp
    };
    AClientKamResetPassword(this.clientResetPasswordRes, payload,getPreLoginData("accTyp"));
  };

  clientResetPasswordRes = (res: any) => {
    if (res.data) {
      this.setState({
        ...this.state,
        errorMsg: "",
        popupMessage: "Password updated successfully",
        screenState: ForgotPasswordScreenEnum.EQUITY_STATUS_SCREEN,
      });
    } else if (res.error) {
      this.setState({
        ...this.state,
        errorMsg: res.error.errMsg,
      });
    }
  };

  removeError = () => {
    this.setState({
      ...this.state,
      errorMsg: "",
    });
  };

  getScreen = () => {
    switch (this.state.screenState) {
      case ForgotPasswordScreenEnum.FORGOT_PASSWORD:
        return <ForgotPasswordForm onSuccess={this.onForgetFormSubmit} />;
      case ForgotPasswordScreenEnum.OTP_SCREEN:
        return (
          <OtpForm
            disableForm={this.state.disableForm}
            errorMsg={this.state.errorMsg}
            onSubmit={this.onSubmitOTPForm}
            onRemoveError={this.removeError}
            onTimerClose={() =>
              this.setState({
                ...this.state,
                screenState: ForgotPasswordScreenEnum.FORGOT_PASSWORD,
              })
            }
          />
        );
      case ForgotPasswordScreenEnum.RESET_OTP_PASSWORD:
        return (
          <ResetOtpPassword
            onSuccess={this.clientKamResetPasswordApi}
            errorMsg={this.state.errorMsg}
            onRemoveError={this.removeError}
            disableForm={this.state.disableForm}            
            onTimerClose={() =>
              this.setState({
                ...this.state,
                screenState: ForgotPasswordScreenEnum.FORGOT_PASSWORD,
              })
            }
          />
        );
      case ForgotPasswordScreenEnum.RESET_PASSWORD:
        return (
          <ResetPassword
            onSuccess={this.clientResetPasswordApi}
            errors={this.state.errorMsg}
            onRemoveError={this.removeError}
          />
        );
      case ForgotPasswordScreenEnum.EQUITY_STATUS_SCREEN:
        return (
          <LoginStatusScreen
            popupState={ELoginPopupState.PASSWORD_UPDATE}
            message={this.state.popupMessage}
            onClose={LoginService.hideCross ? undefined : this.onClose} // don't show close button in vendor login
          />
        );
      case ForgotPasswordScreenEnum.COMMODITY_STATUS_SCREEN:
        return (
          <LoginStatusScreen
            popupState={ELoginPopupState.EMAIL_SENT}
            message={this.state.popupMessage}
            onClose={LoginService.hideCross ? undefined : this.onClose} // don't show close button in vendor login
          />
        );
      default:
        return <></>;
    }
  };

  render() {
    return (
      <>
        <LoginPopup
          leftHeaderContent={
            <Link
              to="/login/help"
              className="ed_button link action icon_button"
            >
              <i className="arrow_left edel-icon-arrow-left vTextTop" />
              <span>Back</span>
            </Link>
          }
          centerHeaderContent={
            DeviceContext().isDesktop ? (
              <img className="logo1" src={NuvamaLogo} alt="nuvama-logo" />
            ) : (
              <h1 className="title">Forgot Password</h1>
            )
          }
          // don't show close button in vendor login
          onClose={LoginService.hideCross ? undefined : this.onClose}
          className="login_scrn frgt_id_form"
        >
          {DeviceContext().isDesktop && (
            <div className="Login_help_header">
              <h1 className="title">Forgot Password</h1>
            </div>
          )}
          {this.getScreen()}
        </LoginPopup>
      </>
    );
  }
}

export default ForgotPasswordScreen;